import React, {useState, useContext, useEffect} from "react";
import Select from "react-select";
import {Link} from "react-router-dom";
import {FilterContext} from "../FilterContextProvider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch, faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import Button from "../Components/Button";
import Input from "../Components/Input";
import ReportsLayout from "./ReportsLayout";
import useEvents from "../hooks/useEvents";
import EventFilter from "../Sales/EventFilter";

const SalesSheetEventsList = () => {
  const {filterData, setFilterData} = useContext(FilterContext);
  const [startingEvents, setStartingEvents] = useState({});
  const [eventFilterDate, setEventFilterDate] = useState({start_date: "", end_date: "", date_button: ""});

  const {
    events,
    pagy,
    setCurrentPage,
    eventDates,
    renderCustomEventDateSelector,
    sortFilter,
    eventIds,
    setEventIds,
    setSortFilter,
    resetPagination,
    setSearchFilter,
  } = useEvents("show", "");

  const sortOptions = [
    {
      label: "Date",
      value: "date",
    },
    {
      label: "City",
      value: "city",
    },
    {
      label: "State",
      value: "state",
    },
    {
      label: "Venue",
      value: "name",
    },
    {
      label: "Recently added",
      value: "created_at",
    },
  ];


  const handleSortSelect = (option) => {
    if (option.value !== sortFilter) {
      setSortFilter(option.value);
      resetPagination();
      setCurrentPage(1);
    }
  };

  const [searchTimeout, setSearchTimeout] = useState();

  const handleSearchChange = (e) => {
    setSearchTimeout(e.target.value);
  };

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setSearchFilter(searchTimeout);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchTimeout, setSearchFilter]);

  const setEvent = (id) => {
    setFilterData({...filterData, event_id: id});
  };

  const handlePageChange = (e) => {
    setCurrentPage(e.target.value);
  };

  useEffect(() => {
    if (events.length > 0 && (startingEvents === undefined || Object.keys(startingEvents).length === 0)) {
      setStartingEvents(events);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events]);

  const renderSelectArtistMessage = () => {
    return (
      <div className="m-8 py-12 pl-4">
        Please select an artist from the filter in order to see events
      </div>
    );
  };

  const renderEventsTable = () => {
    return (
      <div>
        <div>
          <div className="max-w-max">
            <Link to="/reports">
              <div className="-mt-6 mb-6 font-medium text-black text-sm">
                <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Back to
                reports
              </div>
            </Link>
          </div>
          <div className="text-xl mt-7 pb-8 font-medium">Sales Sheet - Select Event</div>
          <div className="-mt-5 mb-4 text-sm">
            <div className="flex">
              <div className="absolute mt-6 ml-2">
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </div>
              <div className="w-1/4 text-xs">
                <Input
                  onChange={handleSearchChange}
                  value={searchTimeout}
                  placeholder="Search for events"
                  label="SEARCH"
                  bigPaddingLeft
                />
              </div>
              <div className="flex flex-col w-1/4 ml-2">
                <span className="text-xs">SORT BY</span>
                <Select
                  id="sort_filter"
                  className="text-xs font-light"
                  placeholder="Select sort by..."
                  options={sortOptions}
                  onChange={handleSortSelect}
                  value={sortOptions?.filter(
                    (each) => each.value === sortFilter
                  )}
                />
              </div>
              <div className="flex flex-col w-1/2 ml-2">
                <span className="text-xs pl-12">Date range/show</span>
                <EventFilter
                  events={events}
                  eventsToRender={startingEvents}
                  setEventsToRender={setStartingEvents}
                  filterData={filterData}
                  eventIds={eventIds}
                  eventFilterDate={eventFilterDate}
                  setEventFilterDate={setEventFilterDate}
                  setEventIds={setEventIds}
                  setFilterData={setFilterData}
                ></EventFilter>
              </div>
            </div>
            <div className="my-4 w-1/2">
              {eventDates.dateButton === "custom" &&
              renderCustomEventDateSelector()}
            </div>
          </div>
        </div>
        {events.length > 0 ? (
          <div>
            <form>
              <table>
                <thead className="text-xs font-light">
                  <tr className="text-left border-b-2 h-11 w-full">
                    <td className="w-1/8 pl-6">DATE</td>
                    <td className="w-1/5">VENUE</td>
                    <td className="w-1/6">CITY</td>
                    <td className="w-thin">STATE</td>
                    <td className="w-1/8">ATTENDANCE</td>
                    <td className="w-thin">TAX RATE</td>
                    <td className="w-thin">CLOTHING HALL FEE</td>
                    <td className="w-thin">MUSIC HALL FEE</td>
                  </tr>
                </thead>
                <tbody>
                  {events.map((eventToRender, i) => {
                    return (
                      <tr
                        key={eventToRender.id}
                        className="border-b text-sm h-11"
                      >
                        <td className="pl-6" id={`date_${i}`}>
                          {eventToRender.formattedDate}
                        </td>
                        <td id={`name_${i}`} className="text-blue-500">
                          <Link
                            to={`/reports/events/${eventToRender.id}/salessheet/`}
                            onClick={() => setEvent(eventToRender.id)}
                          >
                            {eventToRender?.name}
                          </Link>
                        </td>
                        <td id={`city_${i}`}>{eventToRender?.city}</td>
                        <td id={`state_${i}`}>{eventToRender?.state}</td>
                        <td id={`attendance_${i}`}>
                          {eventToRender.attendance &&
                          eventToRender.attendance?.toLocaleString()}
                        </td>
                        <td id={`tax_rate_${i}`}>
                          {Math.round(eventToRender?.tax_rate * 10000) / 100}%
                        </td>
                        <td id={`clothing_hall_rate_${i}`}>
                          {eventToRender.clothing_hall_rate * 100}%
                        </td>
                        <td id={`music_hall_rate_${i}`}>
                          {eventToRender?.music_hall_rate * 100}%
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </form>
          </div>
        ) : sortFilter ? (
          <div className="mx-12 py-16">
            No events match the provided filters
          </div>
        ) : (
          <div className="mx-12 py-16">
            No events have been added for this artist yet
          </div>
        )}
      </div>
    );
  };

  return (
    <ReportsLayout>
      <div>
        <div className="mt-8 mx-8 py-10 px-12 bg-white text-black rounded-lg border">
          {filterData.artist_id
            ? renderEventsTable()
            : renderSelectArtistMessage()}
        </div>
        {events.length > 0 && (
          <footer className="text-sm mt-4 mx-8 pb-4 flex justify-between">
            <div className="ml-1 mr-8">
              Showing <span className="font-bold">{pagy.from} </span>to
              <span className="font-bold"> {pagy.to} </span>of
              <span className="font-bold"> {pagy.count} </span>results
            </div>
            <div className="mr-8">
              Page {pagy.page} of {pagy.last}
            </div>
            <div className="flex -mt-2">
              <span>
                <Button
                  className={
                    pagy.page === 1
                      ? "button-white-disabled button-sm"
                      : "button button-white button-sm"
                  }
                  onClick={resetPagination}
                  text="First"
                  disabled={pagy.page === 1}
                ></Button>
              </span>
              <span className="mx-1">
                <Button
                  value={pagy.prev}
                  className={
                    !pagy.prev
                      ? "button-white-disabled button-sm"
                      : "button button-white button-sm"
                  }
                  onClick={handlePageChange}
                  text="Prev"
                  disabled={!pagy.prev}
                ></Button>
              </span>
              <span>
                <Button
                  value={pagy.next}
                  className={
                    !pagy.next
                      ? "button-white-disabled button-sm"
                      : "button button-white button-sm"
                  }
                  onClick={handlePageChange}
                  text="Next"
                  disabled={!pagy.next}
                ></Button>
              </span>
              <span className="ml-1">
                <Button
                  value={pagy.last}
                  className={
                    pagy.page === pagy.last
                      ? "button-white-disabled button-sm"
                      : "button button-white button-sm"
                  }
                  onClick={handlePageChange}
                  text="Last"
                  disabled={pagy.page === pagy.last}
                ></Button>
              </span>
            </div>
          </footer>
        )}
      </div>
    </ReportsLayout>
  );
};

export default SalesSheetEventsList;
